// extracted by mini-css-extract-plugin
export var featuresMatrixDesktop = "FeaturesMatrix-module--featuresMatrixDesktop--84e8b";
export var featuresMatrixMobile = "FeaturesMatrix-module--featuresMatrixMobile--91f1d";
export var selectLabel = "FeaturesMatrix-module--selectLabel--617e4";
export var selectSection = "FeaturesMatrix-module--selectSection--8b415";